  class RcOrderFlow extends HTMLElement {
    constructor() {
      super();
      console.log('RcOrderFlow');

      this.container = this
      this.section = this.closest('.shopify-section')
      this.selectors = {
        productSelector: `[name="Meal Package"]`,
        sizeSelector: `[size-selector]`,
        startDateSelector: `[custom-start-date-select]`,
        purchaseOption: `[purchase-option-selector]`,
        packageLength: `[package-length-selector]`,
        mealBundleGroup: `[meal-bundle-group-selector]`,
        sideCollection: `[sides-selector]`,
        calendarSelector: 'calendar-input',
        subscription: `[subscription-selector]`,
        sides: `[sides-selector]`,
        mealProductJSON: `[data-meal-product-json]`,
        mealContent: `[data-meal-package-content-json]`
      };

      this.settings = {
        minMealPerDay: parseFloat( this.getAttribute('data-min-meal-per-day') ),
        minPackageDays:  parseFloat( this.getAttribute('data-min-package-days') ),
        dayCountMap: {
          'week_1': parseInt( this.getAttribute('data-meal-count-week-1') ) || 5,
          'week_2': parseInt( this.getAttribute('data-meal-count-week-2') ) || 5,
          'week_3': parseInt( this.getAttribute('data-meal-count-week-3') ) || 5,
          'week_4': parseInt( this.getAttribute('data-meal-count-week-4') ) || 5
        }
      }

      if( this.querySelector(this.selectors.mealProductJSON) === null ) {
        console.error('Meal Product Object Not Found');
        return;
      }
      this.mealProduct = JSON.parse( this.querySelector(this.selectors.mealProductJSON).innerHTML );

      this.mealContent = false;
      if( this.querySelector(this.selectors.mealContent) === null ) {
        console.error(`${this.selectors.mealContent} Object Not Found`);
      }
      this.mealContent = JSON.parse( this.querySelector(this.selectors.mealContent).innerHTML );

      this.enableStepView = true;

      window.onload = () => {
        this.$container = $(this.container);

        this.init();
        this.startingFrom();
        this.populateSelectionsFromParameters();
      };

      window.addEventListener('scroll', () => {
      });
    }

    connectedCallback() {
      /*
      window.addEventListener('scroll', () => {
        const ctaBar = this.querySelector('.order-flow-cta-bar');
        const scrollTop = window.scrollY || document.documentElement.scrollTop;
        const summaryTop = this.querySelector('.payment-summary').offsetTop
        if( (scrollTop+window.innerHeight) > summaryTop) {
          ctaBar.classList.remove('in');
        } else {
          ctaBar.classList.add('in');
        }
      });
      */
    }

    init(){
      this.querySelectorAll(`${this.selectors.packageLength}`).forEach((input)=>{
        input.addEventListener('change', (evt)=>{
          const state = this.getState()
          const $startDateSelect = this.$container.find(this.selectors.startDateSelector)

          if( $startDateSelect.length ) {
            if( state.packageLength == `Subscription` || state.packageLength == `Prepaid` ) {
              // Change start date to first Monday and disable input
              const selectedStartDate = $startDateSelect.val()
              const $selectedStartDateOption = $startDateSelect.find(`option[value="${selectedStartDate}"]`)
              const selectedStartDateDay = $selectedStartDateOption.attr(`data-day`)
              if( selectedStartDateDay !== 'Monday' ) {
                const firstMondayDate = $startDateSelect.find(`option[data-day="Monday"]`).first().attr(`value`)
                $startDateSelect.val(firstMondayDate).change()
              }
              $startDateSelect.attr(`disabled`, `disabled`)
              this.$container.find(`[custom-start-date-wrap]`).addClass(`disabled`)
              this.$container.find(`[data-meal-plan-cta-continue-wrap]`).hide()
              this.$container.find(`[data-meal-plan-cta-add-wrap]`).show()
            } else {
              // Re-enable start date input
              $startDateSelect.removeAttr(`disabled`, `disabled`)
              this.$container.find(`[custom-start-date-wrap]`).removeClass(`disabled`)
              this.$container.find(`[data-meal-plan-cta-continue-wrap]`).show()
              this.$container.find(`[data-meal-plan-cta-add-wrap]`).hide()
            }
          }

          // this.updateSidesAvailability()
          if( state.packageLength == `Subscription` || state.packageLength == `Prepaid` || !$(`[data-step="package-length"]`).next().hasClass('step') ) {
            console.log(state)
            if( $(`[data-step="days"]`).length ) {
              $(`[data-step="days"]`).css('visibility', 'hidden')
            }
            if( typeof( window.Northbeam ) !== 'undefined' ) {
              window.Northbeam.fireCustomGoal('add_to_cart', {})
            }
            window.location.href = this.getMealPackageUrl()
          }
        })
      });

      this.querySelectorAll(`${this.selectors.productSelector}, ${this.selectors.sizeSelector}, ${this.selectors.purchaseOption}, ${this.selectors.packageLength}, ${this.selectors.mealBundleGroup}, ${this.selectors.sideCollection}, ${this.selectors.subscription}, ${this.selectors.sides}, ${this.selectors.startDateSelector}`).forEach((input)=>{
        input.addEventListener('change', (evt)=>{
          this.updateMealPackageUrl()
          this.updatePrice()
          this.updateSummary()
          this.updateMealContent()
          this.updateOptionPrice()
          this.updateStartDateOptions()
          this.updateStep()
        })
      });

      this.querySelectorAll(`${this.selectors.packageLength}`).forEach((input)=>{
        input.addEventListener('change', (evt)=>{
          this.updateCalendarInputs()

          if( this.querySelector(`${this.selectors.packageLength}:checked`).value === '2 Week' ) {
            this.querySelector('[name="Purchase Option"][value="one_off"]').checked = true
          }
        })
      });

      const calendarInput = this.container.querySelector(this.selectors.calendarSelector)
      if( calendarInput !== null ) {
        $(calendarInput).on('nk:change',
          $.debounce(500, function(evt){
            this.updatePrice()
            this.updateMealPackageUrl()

            this.container.querySelectorAll(`[text-meal-count]`).forEach((ele)=>{
              ele.innerHTML = calendarInput.selectedDayCount
            })
            if( calendarInput.selectedDayCount < this.settings.minPackageDays ) {
              this.container.querySelectorAll(`[data-step-day-message-invalid]`).forEach((ele)=>{
                ele.style.display = 'block'
              })
              this.container.querySelectorAll(`[data-step-day-message-valid]`).forEach((ele)=>{
                ele.style.display = 'none'
              })
              this.container.querySelectorAll(`[data-meal-plan-url]`).forEach((ele)=>{
                ele.classList.add('disabled')
                ele.setAttribute('disabled', 'disabled')
              })
            } else {
              this.container.querySelectorAll(`[data-step-day-message-invalid]`).forEach((ele)=>{
                ele.style.display = 'none'
              })
              this.container.querySelectorAll(`[data-step-day-message-valid]`).forEach((ele)=>{
                ele.style.display = 'block'
              })
              this.container.querySelectorAll(`[data-meal-plan-url]`).forEach((ele)=>{
                ele.classList.remove('disabled')
                ele.removeAttribute('disabled')
              })
            }
          }.bind(this))
        )
      }

      this.querySelectorAll(`${this.selectors.productSelector}`).forEach((input)=>{
        input.addEventListener('change', (evt)=>{
          const state = this.getState()

          if( Shopify.shop == 'nutritionkitchenhk.myshopify.com' || Shopify.shop == 'nutritionkitchensg.myshopify.com' ) {
            this.container.querySelector(`${this.selectors.sizeSelector}[value="Large"]`).closest('li').classList.add('hide')
          }
          switch ( state.productHandle ) {
            case 'meal-package-asian':
              // Only Lunch + Dinner options for Asian Menu
              this.container.querySelector(`[name="Meal Bundle Group"][value="Breakfast"]`).checked = false
              this.container.querySelector(`[name="Meal Bundle Group"][value="Breakfast"]`).dispatchEvent( new Event( 'change' ) )
              this.container.querySelector(`.order-flow__option__item[bundle-group-item="Breakfast"]`).classList.add('hide')
              if( Shopify.shop == 'nutritionkitchenhk.myshopify.com' || Shopify.shop == 'nutritionkitchensg.myshopify.com' ) {
                this.container.querySelector(`${this.selectors.sizeSelector}[value="Large"]`).closest('li').classList.remove('hide')
              }
              break;
            case 'meal-package-balanced':
              if( Shopify.shop == 'nutritionkitchenhk.myshopify.com' || Shopify.shop == 'nutritionkitchensg.myshopify.com' ) {
                this.container.querySelector(`.order-flow__option__item[bundle-group-item="Breakfast"]`).classList.remove('hide')
                this.container.querySelector(`${this.selectors.sizeSelector}[value="Large"]`).closest('li').classList.remove('hide')
              }
              break;
            default:
              this.container.querySelector(`.order-flow__option__item[bundle-group-item="Breakfast"]`).classList.remove('hide')
          }
        })
      })

      const buttonBundleGroupContinue = this.querySelector('.button--meal-bundle-group-continue')
      this.querySelectorAll(`${this.selectors.mealBundleGroup}`).forEach((input)=>{
        input.addEventListener('change', (evt)=>{
          const selectedMeals = this.querySelectorAll(`${this.selectors.mealBundleGroup}:checked`).length;
          if( selectedMeals < this.settings.minMealPerDay ) {
            buttonBundleGroupContinue.classList.add('disabled')
          } else {
            buttonBundleGroupContinue.classList.remove('disabled')
          }
        })
      })
      buttonBundleGroupContinue.addEventListener('click', function(evt){
        if( buttonBundleGroupContinue.classList.contains('disabled') ){
          return
        }
        console.log('this', this, 'buttonBundleGroupContinue', buttonBundleGroupContinue);
        this.stepNext(100);
      }.bind(this))

      const rcStartDateInput = this.container.querySelector(`[name="rc_start_date"]`);
      if( rcStartDateInput !== null ) {
        rcStartDateInput.addEventListener('change', function(evt) {
          this.updateCalendarInputs()
        }.bind(this))
        this.updateCalendarInputs()
      }

      if ( this.querySelector('[data-step]') !== null ) {
        this.querySelector('[data-step]').classList.add('step--active')
      }
      if( this.enableStepView ) {
        this.section.querySelectorAll(`[data-step-toggle]`).forEach((toggle)=>{
          toggle.addEventListener('click', function(evt){
            const step = toggle.dataset.stepToggle
            if( typeof(step) !== 'undefined' ) {
              this.stepGoTo(step);
            }
          }.bind(this))
        })
      }
      this.style.opacity = 1
    }

    startingFrom() {
      const startinfFrom = this.querySelector(`[data-starting-from]`);
      const mealVariants = this.mealProduct.variants;
      let lowestPrice = mealVariants[0].price;
      setTimeout(function(){
        mealVariants.forEach((variant)=>{
          if( lowestPrice > variant.price ) {
            lowestPrice = variant.price
          }
        })
        startinfFrom.innerHTML = `<p>Starting from <span class="order-flow__starting-from__badge">HKD ${lowestPrice/100}/Meal</span></p>`
      }, 1000)
    }

    updateStep() {
      const currentStep = this.getCurrentStep()
      const nextStep = this.getNextStep()
      const delay = 300

      const stepSelectMeal = this.container.querySelector('.step-select-your-meal');
      const stepSelectSnack = this.container.querySelector('.step-add-a-snack:not(.disabled)');
      if( currentStep !== 'meal-bundle-group' && stepSelectSnack !== null ) {
        stepSelectMeal.style.display = 'block';
        stepSelectSnack.style.display = 'none';
        stepSelectSnack.classList.remove('active');
      }

      switch ( currentStep ) {
        case 'meal-package':
          this.stepNext(delay)
          break;

        case 'size':
          this.stepNext(delay)
          break;

        case 'meal-bundle-group':
          if( window.innerWidth <= 768 ) {
            const stepMealBundleGroup = this.querySelector(`[data-step="meal-bundle-group"]`)
            if (
              stepMealBundleGroup.classList.contains('step--active') &&
              this.querySelectorAll(`[meal-bundle-group-selector]:checked`).length >= 2
            ) {
              stepMealBundleGroup.classList.remove('step--active')
              stepMealBundleGroup.nextElementSibling.classList.add('step--active')
            }
          }
          break;

        case 'purchase-option':
          this.stepNext(delay)
          break;

        case 'package-length':
          if( this.querySelector(`[package-length-selector]:checked`) !== null ) {
            if( this.getSelectedPackageLength() === '2 Week' ) {
              if( this.querySelector('[name="Purchase Option"][value="one_off"]') !== null ) {
                this.querySelector('[name="Purchase Option"][value="one_off"]').checked = true
                this.updateMealPackageUrl()
                this.updatePrice()
                this.updateSummary()
                this.updateMealContent()
                this.updateOptionPrice()
              }
              this.stepGoTo( 'days', delay )
            } else {
              this.stepNext(delay)
            }
          }
          break;

        case 'sides':
          break;

        default:
          this.stepNext(delay)
          break;
      }

      if( currentStep === 'start-date' || nextStep === 'start-date' ) {
        this.$container.find(`[data-summary-bar]`).hide()
      }
    }

    getCurrentStep() {
      return this.querySelector(`[data-step].step--active`)?.dataset.step
    }

    getNextStep() {
      return this.querySelector(`[data-step].step--active`)?.nextElementSibling?.dataset.step
    }

    stepNext(delay=0) {
      if( !this.enableStepView ) {
        return
      }
      const nextStep = this.getNextStep()
      this.stepGoTo(nextStep, delay)
    }

    stepGoTo( nextStep, delay=0 ) {
      if( !this.enableStepView || typeof(nextStep) == 'undefined' ) {
        return;
      }

      setTimeout(function(){
        this.querySelectorAll(`[data-step]`).forEach((ele)=>{
          ele.classList.remove('step--active')
        })
        this.querySelector(`[data-step="${nextStep}"]`).classList.add('step--active')

        // calculate progress and udpate nav
        const $lastStepNavItem =$(`[data-step-toggle]`).last().closest(`li`)
        const lastStepIndex = parseInt( $lastStepNavItem.attr(`data-step-index`) )
        const $currentStepNavItem = $(`[data-step-toggle="${nextStep}"]`).closest(`li`)
        const currentStepIndex = parseInt( $currentStepNavItem.attr(`data-step-index`) )
        const progressPercent = (currentStepIndex+1) * 1.0 / (lastStepIndex+1) * 100

        $(`[data-step-toggle]`).closest(`li`).removeClass(`current`)
        $currentStepNavItem.addClass(`current`).removeClass(`disabled`)
        $(`.nav__progress__bar`).css(`--progress`, `${progressPercent}%`)

        // if( nextStep === 'start-date' ) {
        //   this.$container.find(`[data-summary-bar]`).hide()
        // }

        if( window.innerWidth <= 768 ) {
          window.scrollTo({
            top: (this.querySelector(`[data-step="${nextStep}"]`).offsetTop - document.querySelector('.mp-header').clientHeight - 20),
            behavior: 'smooth'
          });
        } else {
          window.scrollTo(0, 0)
        }

        this.updateUrlParameters()
      }.bind(this), delay)
    }

    getSelectedMealsPerDay() {
      if( this.getSelectedMealBundleGroup() === '' ) {
        return 0;
      }
      return this.getSelectedMealBundleGroup().split(',').length;
    }

    getSelectedTotalDays( packageLength = this.getSelectedPackageLength() ) {
      const calendarInput = this.container.querySelector(this.selectors.calendarSelector)
      if( calendarInput !== null && calendarInput.selectedDayCount !== 0 ) {
        return calendarInput.selectedDayCount
      }
      const dayCount = this.settings.dayCountMap
      switch ( packageLength ) {
        case 'Subscription':
          return dayCount.week_1;
        case 'Prepaid':
          return dayCount.week_1 + dayCount.week_2 + dayCount.week_3 + dayCount.week_4;
        case '1 Week':
          return dayCount.week_1;
        case '2 Week':
          return dayCount.week_1 + dayCount.week_2;
        case '4 Week':
          return dayCount.week_1 + dayCount.week_2 + dayCount.week_3 + dayCount.week_4;
      }
      return -1;
    }

    getSelectedTotalWeeks( packageLength = this.getSelectedPackageLength() ) {
      switch ( packageLength ) {
        case 'Subscription':
          return 1;
          break;
        case '1 Week':
          return 1;
          break;
        case '2 Week':
          return 2;
          break;
        case '4 Week':
          return 4;
          break;
        default:
          break;
      }
      return -1;
    }

    getSelectedMealBundleGroup() {
      let mealBundleGroup = ''
      this.querySelectorAll(`${this.selectors.mealBundleGroup}:checked`).forEach( (checkbox) => {
        mealBundleGroup += ( mealBundleGroup !== '' ) ? `,${checkbox.value}` : checkbox.value
      })
      return mealBundleGroup;
    }

    getSelectedProductHandle() {
      return ( this.querySelector(`${this.selectors.productSelector}:checked`)?.value || this.querySelector(`${this.selectors.productSelector}`)?.value )
    }

    getSelectedSize() {
      return ( this.querySelector(`${this.selectors.sizeSelector}:checked`)?.value || this.querySelector(`${this.selectors.sizeSelector}`)?.value )
    }

    getSelectedStartDate() {
      return ( $(this.selectors.startDateSelector).length ) ? $(this.selectors.startDateSelector).val() : false
    }

    getSelectedMealPlan() {
      const size = this.getSelectedSize()
      const product = this.getSelectedProductHandle()
      switch ( product ) {
        case 'meal-package-low-carb':
          return `${size} Low Carb`;
          break;
        case 'meal-package-balanced':
          return `${size} Balanced`;
          break;
        case 'meal-package-veggie':
          return `${size} Veggie`;
          break;
        case 'meal-package-flexitarian':
          return `${size} Flexitarian`;
          break;
        case 'meal-package-asian':
          return `${size} Asian`;
          break;
        case 'meal-package-vegan':
          return `${size} Vegan`;
          break;
        default:
      }
      return '';
    }

    getMealVariant(mealPlan, packageLength) {
      const variantTitle = `${mealPlan} / ${packageLength}`;
      for( let i=0 ; i<this.mealProduct.variants.length ; i++ ) {
        const variant = this.mealProduct.variants[i]
        if( variant.title == variantTitle ) {
          return variant;
        }
      }
      return false
    }

    getSelectedMealVariant() {
      const mealPlan = this.getSelectedMealPlan()
      let packageLength = this.getSelectedPackageLength()
      const calendarInput = this.container.querySelector(this.selectors.calendarSelector)
      if( calendarInput !== null && calendarInput.selectedDayCount !== 0 ) {
        if( calendarInput.selectedDayCount < 10 ) {
          packageLength = '1 Week'
        } else if ( calendarInput.selectedDayCount < 20 ) {
          packageLength = '2 Week'
        } else {
          packageLength = '4 Week'
        }
      }
      if( typeof(packageLength) === 'undefined' ) {
        packageLength = '4 Week'
      }

      if( this.querySelector(`[name="Purchase Option"][value="subscription"]`).checked ) {
        switch ( packageLength ) {
          case '1 Week':
            packageLength = 'Subscription'
            break;
          case '4 Week':
            packageLength = 'Prepaid'
            break;
          default:
        }
      }
      return this.getMealVariant(mealPlan, packageLength)
    }

    getState() {
      return {
        size: this.getSelectedSize(),
        sideHandles: this.getSelectedSideHandles(),
        productHandle: this.getSelectedProductHandle(),
        variant: this.getSelectedMealVariant(),
        packageLength: this.getSelectedPackageLength(),
        purchaseOption: this.getSelectedPurchaseOption(),
        mealPlan: this.getSelectedMealPlan(),
        mealBundleGroup: this.getSelectedMealBundleGroup(),
        mealsPerDay: this.getSelectedMealsPerDay(),
        totalDays: this.getSelectedTotalDays(),
        totalWeeks: this.getSelectedTotalWeeks(),
        currentStep: this.getCurrentStep(),
        startDate: this.getSelectedStartDate(),
      }
    }

    getSelectedPackageLength() {
      return this.container.querySelector(`[package-length-selector]:checked`)?.value
    }

    getSelectedPurchaseOption() {
      return $(this.selectors.purchaseOption).filter(':checked').val() || ''//$(this.selectors.purchaseOption).val();
    }

    getSelectedSideHandles() {
      if( !$(`${this.selectors.sides}:checked`).length || $(`${this.selectors.sides}:checked`).val() === null ) {
        return '';
      }
      let handles = ''
      $(`${this.selectors.sides}:checked`).each(function(){
        const val = $(this).val()
        handles += (handles == '') ? `${val}` : `,${val}`
      })
      return handles
    }

    getMealPackageUrl() {
      const state = this.getState()
      let productUrl = `/products/${state.productHandle}?size=${state.size}&meal-bundle-group=${state.mealBundleGroup}`

      if( typeof(state.purchaseOption) !== 'undefined' && state.purchaseOption === 'subscription' ) {
        if( state.packageLength === '1 Week' ) {
          productUrl += `&package-length=Subscription`
        } else if( state.packageLength === '4 Week' ) {
          productUrl += `&package-length=Prepaid`
        }
        productUrl += `&purchase-option=${state.purchaseOption}`
      } else {
        const calendarInput = this.container.querySelector(this.selectors.calendarSelector)
        productUrl += `&package-length=${state.packageLength}`
        if( calendarInput !== null && calendarInput.selectedDayCount !== 0 ) {
          productUrl += `&start-date=${calendarInput.startDate}&end-date=${calendarInput.endDate}&skipped-dates=${calendarInput.skippedDates}`
        } else if( state.startDate ) {
          productUrl += `&start-date=${state.startDate}`
        }
      }

      // append sides if applicable
      productUrl += ( state.sideHandles !== '' ) ? `&sides=${state.sideHandles}` : ''

      return `${productUrl}`
    }

    updateMealContent() {
      const state = this.getState()
      const packageSettings = this.mealContent[state.productHandle];

      if( typeof(state.productHandle) === 'undefined' ) {
        return;
      }

      // // Update meal plan dependant text
      // this.$container.find(`[data-meal-plan-richtext]`).html(``);
      // if( typeof(packageSettings.richtext) !== 'undefined' ){
      //   this.$container.find(`[data-meal-plan-richtext]`).html(`${packageSettings.richtext}`);
      // }

      // this.$container.find(`[data-meal-plan-features]`).html(``);
      // if( typeof(packageSettings.features) !== 'undefined' ){
      //   for (let i=0 ; i<packageSettings.features.length ; i++) {
      //     this.$container.find(`[data-meal-plan-features]`).append(`<li>${packageSettings.features[i]}</li>`);
      //   }
      // }

      // this.$container.find(`[data-size]`).hide().filter(`[data-size="${state.size}"]`).show()

      // Size dependant text
      for (var sizeKey in packageSettings){
        var packageSetting = packageSettings[sizeKey];

        if( typeof(packageSetting.size_description) !== 'undefined' ){
          this.$container.find(`[data-size-description="${sizeKey}"]`).html(`${packageSetting.size_description}`);
        }
        // if( typeof(packageSetting.meals_description) !== 'undefined' ){
        //   const variant = (this.getMealVariant(state.mealPlan, 'Prepaid')) ? this.getMealVariant(state.mealPlan, 'Prepaid') : this.getMealVariant(state.mealPlan, '4 Week');
        //   let meals_description = packageSetting.meals_description.replace('[per-meal-price]', slate.Currency.formatMoney(variant.price, theme.moneyFormat));
        //   this.$container.find(`[data-meals-description="${sizeKey}"]`).html(`${meals_description}`);

        //   document.querySelectorAll(`[data-meals-description]`).forEach( (ele) => {
        //     const eleSize = ele.getAttribute('data-meals-description');
        //     ele.style.display = (eleSize === state.size) ? 'block' : 'none';
        //   });
        //   document.querySelectorAll(`[size-visible]`).forEach( (ele) => {
        //     const eleSize = ele.getAttribute('size-visible');
        //     ele.style.display = (eleSize === state.size) ? 'block' : 'none';
        //   });
        // }
      }
    }

    updateOptionPrice() {
      const state = this.getState()
      let variants = [];
      for( let i=0 ; i<this.mealProduct.variants.length ; i++ ) {
        const variant = this.mealProduct.variants[i];
        if( variant.option1 == state.mealPlan ) {
          variants.push( variant );
        }
      }

      for( let i=0 ; i<variants.length ; i++ ) {
        const variant = variants[i]

        let moneyFormat = theme.moneyFormat
        let moneyFormatNoDecimals = "${{ amount_no_decimals }}"
        if( Shopify.shop == 'nutritionkitchenuae.myshopify.com' ) {
          moneyFormat = '<span style="font-size:.6rem;">AED</span>{{ amount }}';
          moneyFormatNoDecimals = '<span style="font-size:.6rem;">AED</span>{{ amount_no_decimals }}';
        }

        let packageLength = false;
        switch (variant.option2) {
          case 'Subscription':
            packageLength = 'subscription';
            break;
          case 'Prepaid':
            packageLength = 'prepaid';
            break;
          case '1 Week':
            packageLength = '1-week';
            break;
          case '2 Week':
            packageLength = '2-week';
            break;
          case '4 Week':
            packageLength = '4-week';
            break;
          default:
        }

        const optionPriceSelector = `[data-package-length-${packageLength}-price-per-meal]`;
        this.querySelectorAll(optionPriceSelector).forEach((ele)=>{
          if( variant.price%100 === 0 ) {
            ele.innerHTML = slate.Currency.formatMoney(variant.price, moneyFormatNoDecimals)
          } else {
            ele.innerHTML = slate.Currency.formatMoney(variant.price, moneyFormat)
          }
        })
      }
    }

    updateMealPackageUrl() {
      this.querySelectorAll(`[data-meal-plan-url]`).forEach((ele)=>{
        ele.setAttribute('href', this.getMealPackageUrl())
      })
    }

    updatePrice() {
      const state = this.getState()
      const variant = state.variant
      if( !variant ) {
        console.error('Variant not found.')
        return;
      }

      const variantPrice = variant.price;
      const variantCompareAtPrice = variant.compare_at_price;
      let totalPrice = variantPrice * state.totalDays * state.mealsPerDay;
      let totalCompareAtPrice = variantCompareAtPrice * state.totalDays * state.mealsPerDay;
      const totalSaving = totalCompareAtPrice - totalPrice;
      const totalSavingPerWeek = totalSaving / state.totalWeeks;
      const moneyFormat = theme.moneyFormat; // "${{ amount_no_decimals }}";

      // Add side to total prices
      // TODO: Calculate side * 1 week only when prepaid is selected
      const $selectedSideCheckboxes = $(`${this.selectors.sides}:checked`)
      $selectedSideCheckboxes.each(function(){
        const sideVariantPrice = parseInt( $(this).attr(`data-variant-price`) )

        // 1 side item per day
        const sidesTotal = sideVariantPrice * state.totalDays
        totalPrice += sidesTotal
        totalCompareAtPrice += sidesTotal
      })

      // Update per meal price
      this.$container.find(`[data-per-meal-price]`).html( slate.Currency.formatMoney(variantPrice, moneyFormat) );
      this.$container.find(`[data-per-meal-compare-at-price]`).html(``).hide();
      if ( variantCompareAtPrice > variantPrice ) {
        this.$container.find(`[data-per-meal-compare-at-price]`).html( slate.Currency.formatMoney(variantCompareAtPrice, moneyFormat) ).show();
      }

      // Update other prices
      if( this.allOptionsSelected() ) {
        this.$container.find(`[data-meal-plan-url]`).removeAttr('disabled');

        this.$container.find(`[data-total-price-wrapper], [data-per-meal-price-wrapper]`).show();

        this.$container.find(`[data-total-price]`).html( slate.Currency.formatMoney(totalPrice, moneyFormat) );
        if ( totalCompareAtPrice > totalPrice ) {
          this.$container.find(`[data-total-compare-at-price-wrapper]`).show().addClass('in');
          this.$container.find(`[data-total-compare-at-price]`).html( slate.Currency.formatMoney(totalCompareAtPrice, moneyFormat) );
        } else {
          this.$container.find(`[data-total-compare-at-price-wrapper]`).hide().removeClass('in');
          this.$container.find(`[data-total-compare-at-price]`).html('')
        }
        this.$container.find(`[data-summary-bar]`).show()
      } else {
        this.$container.find(`[data-meal-plan-url]`).attr('disabled', 'disabled');
        this.$container.find(`[data-total-price-wrapper], [data-per-meal-price-wrapper]`).hide();
        this.$container.find(`[data-summary-bar]`).hide()
      }

      if( this.allOptionsSelected() && totalCompareAtPrice > totalPrice ) {
        this.$container.find(`[data-total-saving-wrapper], [data-total-saving-per-week-wrapper]`).show();
        this.$container.find(`[data-total-saving-per-week]`).html( slate.Currency.formatMoney(totalSavingPerWeek, moneyFormat) );
        this.$container.find(`[data-total-saving]`).html( slate.Currency.formatMoney(totalSaving, moneyFormat) );
      } else {
        this.$container.find(`[data-total-saving-wrapper], [data-total-saving-per-week-wrapper]`).hide();
      }

      if( state.totalDays !== -1 ) {
        this.querySelectorAll('[data-price-per-day]').forEach((ele)=>{
          ele.innerHTML = slate.Currency.formatMoney( (totalPrice*1.0/state.totalDays), moneyFormat)
        })
      }
    }

    updateStartDateOptions() {
      console.log('updateStartDateOptions')
      this.querySelectorAll('[name="rc_start_date"] option').forEach( (option) => {
        option.classList.remove('hide')
        if( this.getState().purchaseOption === 'subscription' && option.innerHTML.includes('Wednesday') ) {
          option.classList.add('hide')
        }
      })
    }

    getMealsPerDay() {
      return (this.querySelectorAll('[name="Meal Bundle Group"]:checked').length - this.querySelectorAll('[name="Meal Bundle Group"][value="Side"]:checked').length)
    }

    updateSummary() {
      const state = this.getState();

      let packageLength = ''
      switch ( state.packageLength ) {
        case '1 Week':
          packageLength = '5 days';
          break;
        case '2 Week':
          packageLength = '10 days';
          break;
        case '4 Week':
          packageLength = '20 days';
          break;
        default:
          packageLength = state.packageLength;
          break;
      }

      let purchaseOption = ''
      switch ( state.purchaseOption ) {
        case 'subscription':
          purchaseOption = ', Subscription';
          break;
        default:
          purchaseOption = '';
          break;
      }

      let snacks = ''
      if( this.querySelectorAll('[name="Meal Bundle Group"][value="Side"]:checked').length ) {
        snacks = ', 1 snack'
      }

      /*
      let packageName = '';
      if( ( typeof(state.productHandle )!== 'undefined' )) {
        switch ( state.productHandle ) {
          case 'meal-package-balanced':
            packageName = 'Balanced';
            break;
          case 'meal-package-low-carb':
            packageName = 'Low Carb';
            break;
          case 'meal-package-veggie':
            packageName = 'Vegetarian';
            break;
          case 'meal-package-asian':
            packageName = 'Asian';
            break;
          default:
            packageName = state.productHandle;
            break;
        }
      }
      */

      this.querySelector('.payment-summary__body').style.display = 'block';
      this.querySelectorAll('[summary-selection-text]').forEach(ele=>{
        ele.innerHTML = `${this.getMealsPerDay()} Meals${snacks}, ${packageLength}${purchaseOption}`;
      })

      console.log('update summary')
      const ctaBar = this.querySelector('.order-flow-cta-bar')
      ctaBar.querySelectorAll('.cta-bar__content').forEach((ele)=>{
        ele.style.display = 'none'
      })
      if( this.querySelector(`${this.selectors.productSelector}:checked`) === null ) {
        ctaBar.querySelector('.cta-bar__content--meal-package').style.display = 'block'
      } else if ( this.querySelector(`${this.selectors.sizeSelector}:checked`) === null ) {
        ctaBar.querySelector('.cta-bar__content--size').style.display = 'block'
      } else if ( this.querySelectorAll(`${this.selectors.mealBundleGroup}:checked`).length < 2 ) {
        ctaBar.querySelector('.cta-bar__content--meal-bundle-group').style.display = 'block'
      } else if ( this.querySelector(`${this.selectors.packageLength}:checked`) === null ) {
        ctaBar.querySelector('.cta-bar__content--package-length').style.display = 'block'
      } else if ( this.querySelector(`${this.selectors.purchaseOption}:checked`) === null ) {
        ctaBar.querySelector('.cta-bar__content--purchase-option').style.display = 'block'
      } else {
        ctaBar.style.display = 'none'
      }
      // ctaBar.querySelector('cta-bar__content--days').style.display = 'block'

      ctaBar.querySelectorAll('[summary-selection-text]').forEach(ele=>{
        // ele.innerHTML = `${packageName}, ${state.size}, ${this.querySelectorAll(`[name="meal-bundle-group"]:checked`).length} meals`;
      })
    }

    updateCalendarInputs() {
      const state = this.getState()
      const totalDays = state.totalWeeks * 5
      const calendarInput = this.container.querySelector(this.selectors.calendarSelector)
      if( calendarInput === null ) {
        return
      }

      const startDate = ( typeof(this.querySelector(`[name="rc_start_date"]`)?.value) !== 'undefined' ) ? this.querySelector(`[name="rc_start_date"]`)?.value : false
      calendarInput.populateDays( totalDays, startDate )
      if(
      calendarInput.querySelector(`input:checked`) !== null ) {
        calendarInput.querySelector(`input:checked`).dispatchEvent( new Event('change') )
      } else {
        calendarInput.querySelector(`input`).dispatchEvent( new Event('change') )
      }
    }

    updateUrlParameters() {
      const state = this.getState()
      let currentStep = state.currentStep
      switch (currentStep) {
        case 'meal-package':
          currentStep = `meal-plan`;
          break;
        case 'meal-bundle-group':
          currentStep = `meals`;
          break;
        case 'package-length':
          currentStep = `length`;
          break;
        default:
      }

      let data = {
        'meal-package': state.productHandle,
        'size': state.size,
        'purchase-option': state.purchaseOption,
        'package-length': state.packageLength,
        'meal-bundle-group': state.mealBundleGroup,
        'step': currentStep,
        'view': 'rc-order-flow',
      }

      const searchParams = Object.fromEntries(new URLSearchParams(location.search))
      if( typeof(searchParams['v']) !== 'undefined' ) {
        data['v'] = searchParams['v']
      }

      /*
      // append sides if applicable
      if( state.sideHandles !== '' ) {
        data['sides'] = state.sideHandles
      }

      if( state.startDate ) {
        data['start-date'] = state.startDate
      }
      */

      // Update url
      let pathname = window.location.pathname,
          newPathname = ( $.param(data) == "" ) ? pathname : `${pathname}?${$.param(data)}`
      window.history.pushState({}, "", newPathname )
    }

    allOptionsSelected() {
      const selectorKeys = ['productSelector', 'sizeSelector', 'packageLength', 'mealBundleGroup'];
      for( let i=0 ; i<selectorKeys.length ; i++ ) {
        if( $(this.selectors[selectorKeys[i]]).filter(':checked').length == 0 ){
          return false;
        }
      }
      const selectedMeals = this.querySelectorAll(`${this.selectors.mealBundleGroup}:checked`).length;
      if( selectedMeals < this.settings.minMealPerDay ) {
        return false;
      }
      return true;
    }

    populateSelectionsFromParameters() {
      const searchParams = Object.fromEntries(new URLSearchParams(location.search));

      if( Object.keys(searchParams).length === 0 ) {
        return;
      }

      // Populate meal-package
      if( typeof(searchParams['meal-package']) !== 'undefined' ) {
        $(`${this.selectors.productSelector}[value="${searchParams['meal-package']}"]`).prop('checked', true)
        this.stepGoTo('size', 600)
      }

      // Populate size
      if( typeof(searchParams['size']) !== 'undefined' ) {
        $(`${this.selectors.sizeSelector}[value="${searchParams['size']}"]`).prop('checked', true)
        this.stepGoTo('meal-bundle-group', 600)
      }

      // Populate meal-bundle-group
      if( typeof(searchParams['meal-bundle-group']) !== 'undefined' ) {
        const bundleGroups = searchParams['meal-bundle-group'].split(',');
        for( let i=0 ; i<bundleGroups.length; i++ ) {
          const bundleGroup = bundleGroups[i];
          $(`${this.selectors.mealBundleGroup}[value="${bundleGroup}"]`).prop('checked', true)
        }
        this.stepGoTo('purchase-option', 600)
      }

      // Populate purchase-option
      if( typeof(searchParams['purchase-option']) !== 'undefined' ) {
        $(`${this.selectors.purchaseOption}[value="${searchParams['purchase-option']}"]`).prop('checked', true)
        this.stepGoTo('package-length', 600)
      }

      // Populate package-length
      if( typeof(searchParams['package-length']) !== 'undefined' ) {
        $(`${this.selectors.packageLength}[value="${searchParams['package-length']}"]`).prop('checked', true)
      }


      // Populate sides
      /*
      if( typeof(searchParams['sides']) !== 'undefined' ) {
        const $sidesInput = $(`${this.selectors.sides}`)
        if( $sidesInput.length && $sidesInput.find(`option[value="${searchParams['sides']}"]`).length ) {
          $sidesInput.val(searchParams['sides']);
        }
      }
      */

      if( typeof(searchParams['meal-package']) !== 'undefined' || typeof(searchParams['size']) !== 'undefined' || typeof(searchParams['package-length']) !== 'undefined' || typeof(searchParams['meal-bundle-group']) !== 'undefined' || typeof(searchParams['sides']) !== 'undefined' ) {
        $(`${this.selectors.productSelector}`).trigger(`change`);
      }

      if( typeof(searchParams['v']) !== 'undefined' ) {
          switch (searchParams['v']) {
            case '1':
              $(`[data-test]`).addClass(`hide`)
              $(`[data-test="1"]`).removeClass(`hide`)
              break;

            case '2':
              $(`[data-test]`).addClass(`hide`)
              $(`[data-test="2"]`).removeClass(`hide`)
              break;
            default:
          }
      }
    }
  }

  if (!customElements.get('rc-order-flow')) {
    customElements.define('rc-order-flow', RcOrderFlow);
  }
